import React, {useEffect, useState, useRef, useContext} from "react";
import {store} from '../context/store';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";


import {LICENCE_KEY} from "../constants/charts";

//am4core.useTheme(am4themes_animated);

am4core.addLicense(LICENCE_KEY);

export default function AmChartWaterfall({chartId, width, height, chartData, categoryKey, openCloseKeys, onClick}){

	const chart = useRef(null);
	const globalState = useContext(store);

	useEffect(() => {
		let x = am4core.create(chartId, am4charts.XYChart);
		x.data = chartData;
		x.fontSize=12;
		x.stroke = 'black';
		x.strokeOpacity = 0;
	
		var categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
		categoryAxis.dataFields.category = "category";
		categoryAxis.renderer.grid.template.location = 0;
		categoryAxis.renderer.minGridDistance = 30;
		categoryAxis.renderer.ticks.template.disabled = false;
		categoryAxis.renderer.ticks.template.strokeOpacity = 0.5;
		categoryAxis.renderer.labels.template.rotation=-90;
		categoryAxis.renderer.labels.template.strokeOpacity=0;
		categoryAxis.renderer.labels.template.fillOpacity=1;
		categoryAxis.renderer.labels.template.fill='black';
	
		
		var valueAxis = x.yAxes.push(new am4charts.ValueAxis());
		valueAxis.renderer.labels.template.fill='black';
		valueAxis.calculateTotals = true;
		valueAxis.renderer.labels.template.strokeOpacity=0;
		valueAxis.renderer.labels.template.fillOpacity=1;
		valueAxis.renderer.labels.template.fill='black';
		
		// Create series
		function createSeries(open, close, name, showSum, color) {
		  var series = x.series.push(new am4charts.ColumnSeries());
		  series.dataFields.valueY = close;
		  series.dataFields.openValueY = open;
		  series.name = name;
		  series.dataFields.categoryX = categoryKey;
		  series.clustered = false;
		  series.strokeWidth = 0;
		  series.columns.template.width = am4core.percent(90);
		  
		  series.columns.template.events.on("hit", function(event) {
				onClick(event.target.dataItem.properties.category);
			});
		 
		  var labelBullet = series.bullets.push(new am4charts.LabelBullet());
		  labelBullet.label.hideOversized = true;
		  labelBullet.label.fill = 'black';
		  labelBullet.label.text = "{valueY}";
		  labelBullet.label.adapter.add("text", function(text, target) {
		    var val = Math.abs(target.dataItem.valueY - target.dataItem.openValueY);
		    return val;
		  });
		  
		  labelBullet.locationY = 0.5;
		  
		  if (showSum) {
		    var sumBullet = series.bullets.push(new am4charts.LabelBullet());
		    sumBullet.label.text = "{valueY.close}";
		    sumBullet.verticalCenter = "bottom";
		    sumBullet.dy = -8;
		    sumBullet.label.fill = 'black';
		    sumBullet.label.adapter.add("text", function(text, target) {
		      var val = Math.abs(target.dataItem.dataContext.close2 - target.dataItem.dataContext.open1);
		      return val;
		    });
		  }
		}
		
		for(let i=0; i<openCloseKeys.length; i++){
			createSeries(openCloseKeys[i].open, openCloseKeys[i].close, openCloseKeys[i].label, openCloseKeys[i].showTotal, openCloseKeys[i].color);
		}
		

		var legend = new am4charts.Legend();
		legend.position = "top";
		legend.valign = "top";
		legend.labels.template.strokeOpacity=0; 
  	legend.labels.template.fillOpacity=1; 
  	legend.labels.template.fill='black'; 
		
		x.legend = legend;

		x.color = 'black';
		chart.current = x;
		
		
		return () => {
			x.dispose();
		};
		
	}, [chartData, openCloseKeys]);
	
	
	
		
	return (
		<div id={chartId} style={{ width: width, height: height }}></div>
	);
}